import { render, staticRenderFns } from "./MyReports.vue?vue&type=template&id=5226e98c"
import script from "./MyReports.vue?vue&type=script&lang=js"
export * from "./MyReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports